import moment from "moment";
import React from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import styled from "styled-components";

const Card = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  padding: 16px;
  border: 1px solid #dddddd;
  border-radius: 8px;
  margin-bottom: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  cursor: pointer;

   &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    /* transform: translateY(-2px); */
    border-color: #0066cc;
  }
`;

const Left = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

const Avatar = styled.div<{ bg?: string }>`
  background: ${({ bg }) => bg || "#0066cc"};
  color: gray;
  font-weight: bold;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
`;

const TextPart = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Title = styled.div`
  font-weight: 600;
`;

const Description = styled.div`
  font-size: 13px;
  color: #444;
`;

const Subtitle = styled.div`
  font-size: 12px;
  color: #777;
`;

const InfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

const Right = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Amount = styled.div`
  font-weight: bold;
  font-size: 16px;
  color: #333;
`;

const Dollar = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  border: 2px solid #999999;
  border-radius: 50%;

  img {
    width: 100%;
    object-fit: contain;
  }
`;
const ActionButton = styled.button<{ actionType?: "review" | "approve" | "rejected" }>`
  color: ${({ actionType }) =>
    actionType === "approve" ? "#219150" : 
    actionType === "rejected" ? "#DC3545" : "#0066cc"};
  background-color: #ffffff;
  border: none;
  padding: 0.4rem 0.935rem;
  border-radius: 6px;
  font-size: 0.875rem;
  cursor: pointer;
  border: 1px solid
    ${({ actionType }) => 
      actionType === "approve" ? "#27ae60" : 
      actionType === "rejected" ? "#DC3545" : "#0066cc"};

  &:hover {
    background-color: ${({ actionType }) =>
      actionType === "approve" ? "#219150" : 
      actionType === "rejected" ? "#DC3545" : "#0066cc"};
    color: #ffffff;
  }
`;


const CreatedAt = styled.div`
  font-size: .75rem;
  color: #999;
  font-style: italic;
  margin-top: 2px;
`;

interface ExpenseCardProps {
  data: {
    id: number;
    purchase_amount: number;
    description: string;
    spent_at: string;
    spent_on: string;
    status: string;
    is_reimbursable: boolean;
    category?: string;
    decline_reason?: string;
    employee: {
      name: string;
    };
  };
}

const ToReviewCard: any = ({ data, bgColor, onApprove, onReject, openExpense }: any) => {
  const getInitials = (name: string) => {
    return name
      .split(" ")
      .map((n) => n?.[0])
      .join("");
  };

  return (
    <Card onClick={() => openExpense(data)}>
      <Left>
        <Avatar bg={bgColor}>{getInitials(data?.employee.name)}</Avatar>
        <Dollar>
          <img src="/Pay Runs.svg" alt="Dollar Icon" />
        </Dollar>
        <TextPart>
          <InfoRow>
            <Title>{data?.spent_at}</Title>
            <Description>"{data?.description}"</Description>
          </InfoRow>
          <Subtitle>
            {data?.employee.name} ·{" "}
            {new Date(data?.spent_on).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })}{" "}
            · {data?.category && `${data?.category} · `}
            {!data?.is_reimbursable ? (
              <span style={{ color: "#FF0000" }}>Non-Reimbursement</span>
            ) : (
              "Reimbursable"
            )}
            {data?.decline_reason && (
              <span style={{ color: "#FF0000" }}> · {data?.decline_reason}</span>
            )}
          </Subtitle>


          <CreatedAt>
            Created: {moment(data?.created_at).format("DD MMM YYYY, hh:mm A")}
          </CreatedAt>
        </TextPart>
      </Left>
      <Right>
        <Amount>${data?.purchase_amount.toFixed(2)}</Amount>
        {/* {data?.status === "submitted" && (
                    <ActionButton actionType="review">Review</ActionButton>
                )} */}
        {(data?.status === "submitted") && (
          <>
            <ActionButton actionType="approve" onClick={(e)=> {e.stopPropagation(); onApprove(data?.id)}}>Approve</ActionButton>
            <ActionButton actionType="rejected" onClick={(e)=> {e.stopPropagation(); onReject(data?.id)}}>Reject</ActionButton>
          </>
        )}
        {/* <BsThreeDotsVertical color="#999999" size={20} /> */}
      </Right>
    </Card>
  );
};

export default ToReviewCard;
